if (!customElements.get("sticky-atc")) {
  class StickyATC extends HTMLElement {
    constructor() {
      super({
        name: "Sticky ATC",
        version: "2.0.0",
      });
    }

    connectedCallback() {
      this.stickyATCUpper = document.querySelector(".section-main-product");

      if (!this.stickyATCUpper) return;

      this.button = this.querySelector("[data-sticky-atc-btn]");
      //this.colorSelector = this.querySelector('.product__color-selector')
      this.variantSelector = this.querySelector(".product__variant-selector");

      document.documentElement.style.setProperty("--footer-offset", `${this.offsetHeight + 20}px`);

      new IntersectionObserver(this.handleUpperIntersect.bind(this), { threshold: 0.2 }).observe(this.stickyATCUpper);

      //this.colorSelectorDrawerListener()
      this.variantSelectorListener();

      this.button.addEventListener("click", this.onClickHandler.bind(this));

      this.mobileButton = this.querySelector(".mobile-trigger button");
      this.mobileButton?.addEventListener("click", this.onClickHandlerMobile.bind(this));
    }

    disconnectedCallback() {
      if (!this.stickyATCUpper) return;

      // disconnect IntersectionObserver
      const observer = new IntersectionObserver(this.handleUpperIntersect.bind(this), { threshold: 0.2 });
      observer.unobserve(this.stickyATCUpper);
    }

    handleUpperIntersect(entries, observer) {
      //this.colorSelector = this.querySelector('.product__color-selector')
      this.variantSelector = this.querySelector(".product__variant-selector");

      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // hide when scrolling up
          document.querySelector("sticky-atc").style.transform = "translateY(calc(100% + var(--layout-space-24)))";
          this.variantSelector?.classList.remove("active");
          //this.colorSelector?.classList.remove('active')
        } else {
          // show when scrolling down
          document.querySelector("sticky-atc").style.transform = "translateY(0)";
          this.variantSelector?.classList.remove("active");
          //this.colorSelector?.classList.remove('active')
        }
      });
    }

    /*
  colorSelectorDrawerListener() {
    this.colorSelector?.querySelector('.product__color-selector--wrapper').addEventListener('click', () => {
      this.colorSelector.classList.toggle('active')
      this.variantSelector?.classList.remove('active')
    })
  }
  */

    variantSelectorListener() {
      this.variantSelector?.querySelector(".product__variant-selector--wrapper").addEventListener("click", () => {
        let productDescriptionTop = document.querySelector(".product__info-container").offsetTop;

        window.scroll({ top: productDescriptionTop, behavior: "smooth" });
        //this.variantSelector.classList.toggle('active')
        //this.colorSelector?.classList.remove('active')
      });
    }

    onClickHandler(event) {
      event.preventDefault();
      var mainAtc = document.querySelector("product-form .product-form__submit");
      if (mainAtc) {
        mainAtc.click();
      }
    }

    onClickHandlerMobile(event) {
      event.preventDefault();
      // Scroll to top on mobile devices
      if (window.innerWidth < 750) {
        let productVariant = document.querySelector(".product__variant-selector");
        let productDescription = document.querySelector(".product__info-container");

        let productScrollTop = productVariant.offsetTop + 17;

        if (!productVariant) {
          productScrollTop = productDescription.offsetTop;
        }

        window.scroll({ top: productScrollTop, behavior: "smooth" });
        //window.scroll({ top: 0, behavior: "smooth" });
      }
      var mainAtc = document.querySelector("product-form .product-form__submit");
      if (mainAtc) {
        //mainAtc.click();
      }
    }
  }

  customElements.define("sticky-atc", StickyATC);
}
